// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, browserLocalPersistence, setPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCmTa5vuVVv4Kd5-rUHv8Cj88ffNXpBnv8",
  authDomain: "achintya-orgz.firebaseapp.com",
  databaseURL: "https://achintya-orgz-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "achintya-orgz",
  storageBucket: "achintya-orgz.firebasestorage.app",
  messagingSenderId: "349293195234",
  appId: "1:349293195234:web:7c24367220d3826f81d3bb",
  measurementId: "G-T0H1W3FCWP"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
setPersistence(auth, browserLocalPersistence).catch(console.error);
export const db = getFirestore(app, 'delhi');
export const rtdb = getDatabase(app);    // Realtime Database
